// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"f1ac323ae3402834","5285":"36936427f083f3fb"}[chunkId] + ".css";
};